/**
 * Calculates the correct item number for a paginated list.
 * Ensures numbering continues across all pages.
 */
export function itemNumber(index, item) {
    const currentPage = item.current_page 
        ?? item.meta?.current_page 
        ?? 1;

    const perPage = item.per_page 
        ?? item.meta?.per_page 
        ?? 10;

    return (currentPage - 1) * perPage + (index + 1);
}

/**
 * Formats a score for display
 * - 0 -> "0"
 * - other numbers -> 1 decimal place
 *
 * @param {number} score
 * @returns {string}
 */
export function formatScore(score) {
    return Number(score) % 1 === 0 
        ? Number(score)           
        : Number(score).toFixed(1);
};

export function formatDate (date) {
    if (!date) return '—'; 
    const d = new Date(date);
    if (isNaN(d)) return date; 
    return d.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

export function capitalize(str = '') {
    return String(str)
        .replace(/_/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase());
}